import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { UserRole } from '../../types/enums';
import WelcomeBanner from './WelcomeBanner';

const PrivateRoute = ({ requireAdmin = false, requireFacilityAdmin = false, allowedRoles = [] }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  // Show welcome banner while authentication state is being determined
  if (loading) {
    return <WelcomeBanner />;
  }

  if (!user) {
    // Capture the intended destination and redirect to login with it
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Get user roles using the new role system
  const userRoles = user?.roles || [user?.role].filter(Boolean);
  
  // Check for specific role requirements
  if (allowedRoles.length > 0) {
    const hasAllowedRole = allowedRoles.some(allowedRole => userRoles.includes(allowedRole));
    if (!hasAllowedRole) {
      return <Navigate to="/dashboard" />;
    }
  } else {
    // Check for admin/facility_admin requirements if no specific roles are provided
    if (requireAdmin && !userRoles.includes(UserRole.ADMIN)) {
      return <Navigate to="/dashboard" />;
    }

    if (requireFacilityAdmin && !userRoles.includes(UserRole.ADMIN) && !userRoles.includes(UserRole.FACILITY_ADMIN)) {
      return <Navigate to="/dashboard" />;
    }
  }

  return <Outlet />;
};

export default PrivateRoute;
